import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Notfound from './pages/Notfound'
import Home from './pages/Home';
import Header from './components/Header';
import ScrollTop from './components/ScrollTop';
import Schedule from './pages/Schedule';
import Residents from './pages/Residents';
import Sponsors from './pages/Sponsors';
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import About from './pages/About';
import Apply from './pages/Apply';
import Genre_Sort from './pages/Genre_Sort';
import Resident_Detail from './pages/Resident_Detail';
import Player from './components/Player';
import { CartProvider } from './context/CartContext';
import { useEffect } from 'react';
import { ProductProvider } from './context/productContext';
import ProductDetail from './pages/ProductDetail';
import ThankYou from './pages/ThankYou';


function App() {

    useEffect(() => {
        localStorage.removeItem("audio_data");
    }, [])

    return (
        <>
            <ProductProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Header />
                        <Player />
                        <ScrollTop />
                        <Routes>
                            <Route path="/*" element={<Notfound />} />
                            <Route path="/" element={<Home />} />
                            <Route path="/schedule" element={<Schedule />} />
                            <Route path="/presenters" element={<Residents />} />
                            <Route path="/presenter/:gen" element={<Genre_Sort />} />
                            <Route path="/presenter-detail/:id" element={<Resident_Detail />} />
                            <Route path="/sponsors" element={<Sponsors />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/thankyou" element={<ThankYou />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/about-us" element={<About />} />
                            <Route path="/application-form" element={<Apply />} />
                        </Routes>
                    </BrowserRouter>
                </CartProvider>
            </ProductProvider>
        </>

    );
}

export default App;